<div>
  <mat-card class="msg-attach " style="box-shadow: none; min-height: calc(100vh - 180px);">
    <div class="msg-attach-title">Message and attachments</div>
      <div class="msg-attach-sub-title">Message </div>
      <div class="msg-attach-subject">
      <mat-form-field appearance="outline" oneFormField style=" width: 100%;
      flex: 1;">
        <mat-label>Subject</mat-label>    
        <input matInput value="" [formControl]="subjectname" (keyup)="onKeyupSubjectName($event)" (blur)="onBlurSubjectName($event)" min="5" max="250" />
        <button mat-icon-button one-icon-button matSuffix (click)="subjectname.setValue('')" style="height: 27px;" *ngIf="subjectname.value">
          <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix>clear </mat-icon>
        </button>
      </mat-form-field>
      <button mat-stroked-button one-secondary-button style="margin-left: 24px;" (click)="openMsgAttachTempleteDialog()">
        Templates
      </button>
    </div>   
  
    <dl-rich-text-document [jsonTextItem]="textDoc" [showInEditor]="" (jsonTextReturn)="setRTEText($event)"></dl-rich-text-document>

    <div class="msg-attach-templete-apply">
      <mat-checkbox [(ngModel)]="addTempleteCheck" (change)="chkApplyChange($event)" [disabled]="disabledApplyCheckbox" style="flex:1">Add this message to your templates</mat-checkbox>
      <button mat-stroked-button one-secondary-button [disabled]="disbledApplyButton" (click)="onApplybuttonAction()">
        Apply
      </button>
    </div>
    <div class="msg-attach-sub-title top-margin-24">Attachments </div>
    <dl-file-upload-multiple [fileUploadwithCheck]="'multiple'"></dl-file-upload-multiple>
  </mat-card>   
</div>